import React from 'react';
import Router from 'Routes';
import { SelectionProvider } from 'context/SelectionContext';

function App() {
  return (
    <SelectionProvider>
      <Router />
    </SelectionProvider>
  );
}

export default App;
